import dayjs from "dayjs";

const getOrdinalSuffix = (day) => {
  if (day > 3 && day < 21) return "th";
  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

export const formatSlashDate = (value) => {
  if (!value) return "-";
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format("MM/DD/YYYY") : value;
};

export const formatCampaignDate = (value) => {
  if (!value) return "-";
  const parsed = dayjs(value);
  if (!parsed.isValid()) return value;
  const day = parsed.date();
  return `${day}${getOrdinalSuffix(day)} ${parsed.format("MMMM, YYYY")}`;
};

export const formatCampaignTime = (value, timezone) => {
  if (!value) return "-";
  const raw = String(value).trim();
  const parsed = raw.includes("T") ? dayjs(raw) : dayjs(`1970-01-01T${raw}`);
  if (!parsed.isValid()) {
    return timezone ? `${raw} ${timezone}` : raw;
  }
  const formatted = parsed.format("hh:mm A");
  return timezone ? `${formatted} ${timezone}` : formatted;
};

export const formatOutreachWindowTime = (time) => {
  if (!time) return "";
  const parsed = dayjs(`1970-01-01T${time}`);
  if (!parsed.isValid()) return time;
  return parsed.format("h:mm a");
};

export const formatMonthDayYearDate = (value) => {
  if (!value) return "-";
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format("MMMM D, YYYY") : value;
};

export const getCampaignStatus = (status) => {
  if (status == null || String(status).trim() === "") {
    return null;
  }
  switch (String(status).trim().toLowerCase()) {
    case "hold":
      return (
        <div
          className="activted"
          style={{ backgroundColor: "#F4E6D7", color: "#A66A2C" }}
        >
          Hold
        </div>
      );
    case "active":
      return (
        <div
          className="activted"
          style={{ backgroundColor: "#E2F9DD", color: "#276E2E" }}
        >
          Active
        </div>
      );
    case "archive":
    case "archived":
      return (
        <div
          className="activted"
          style={{ backgroundColor: "#EBEBEB", color: "#5C5C5C" }}
        >
          Archived
        </div>
      );
    case "draft":
      return (
        <div
          className="activted"
          style={{ backgroundColor: "#D6EDFF", color: "#306EDC" }}
        >
          Draft
        </div>
      );
    default:
      return null;
  }
};

/** Canonical key for toolbar / modal logic: hold | active | archive | draft | unknown */
export const normalizeCampaignStatusKey = (status) => {
  if (status == null || String(status).trim() === "") return "unknown";
  const s = String(status).trim().toLowerCase();
  if (s === "hold") return "hold";
  if (s === "active") return "active";
  if (s === "archive" || s === "archived") return "archive";
  if (s === "draft") return "draft";
  return "unknown";
};

export const aiCampaignsColumns = (navigate, options = {}) => {
  const { showView = false, showManage = true } = options;

  return [
  {
    title: "Campaign Name",
    dataIndex: "campaignName",
    key: "campaignName",
  },
  {
    title: "Campaign Type",
    dataIndex: "campaignType",
    key: "campaignType",
    render: (key) => {
      return (
        <div
			  className="campaingtype activted gothamBook"
			 
        >
          {key || "-"}
        </div>
      );
    },
  },
  {
    title: "Campaign Duration",
    dataIndex: "campaignDuration",
    key: "campaignDuration",
    render: (key) => {
      return (
        <div>{key || "-"}</div>
      );
    },
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (key) => {
      return getCampaignStatus(key);
    },
  },
  {
    title: "Action",
    key: "action",
    render: (row) => {
      if (!showView && !showManage) {
        return null;
      }

      const navigateToCampaign = () => {
        navigate("/ai-campaigns/manage-ai-campaign", {
          state: { campaignId: row?.id, refBrandId: row?.refBrandId },
        });
      };

      return (
        <div className="action-icons">
          <div className="grid2 d-flex">
            {showManage && (
              <button
                className="manage"
                style={{
                  fontFamily: "Gotham",
                  fontWeight: "400 ",
                }}
                type="button"
                onClick={navigateToCampaign}
              >
                Manage
              </button>
            )}
            {showView && (
              <button
                className="manage"
                style={{
                  fontFamily: "Gotham",
                  fontWeight: "400 ",
                }}
                type="button"
                onClick={navigateToCampaign}
              >
                View
              </button>
            )}
          </div>
        </div>
      );
    },
  },
];
};
